// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.grid-card-container {
    padding-top: 0;
}

.grid-card {
    flex-grow: 1;
    height: 100%;
    min-height: 420px;
    display: flex;
    flex-direction: column;
    border-radius: 12px;
    box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);
    padding: 0 !important;
    background-color: #fff;
}

.grid-card-border-success {
    border-bottom: 6px solid #4caf50;
}

.grid-card-border-secondary {
    border-bottom: none;
}

.grid-card-border-info {
    border-bottom: 6px solid #2196f3;
}

.grid-card-border-warning {
    border-bottom: 6px solid #ff9800;
}

.grid-card-border-primary {
    border-bottom: 6px solid #9c27b0;
}

.grid-card-media {
    display: flex;
    align-items: center;
    justify-content: center;
    overflow: hidden;
    position: relative;
    height: 180px;
    padding-top: 0;
}

.grid-card-media-success {
    background-color: #4caf50;
}

.grid-card-media-secondary {
    background-color: #9e9e9e;
}

.grid-card-media-info {
    background-color: #2196f3;
}

.grid-card-media-warning {
    background-color: #ff9800;
}

.grid-card-media-primary {
    background-color: #9c27b0;
}

.grid-card-thumbnail {
    width: 100%;
    height: 100%;
    object-fit: cover;
}

.grid-card-play-icon {
    position: absolute;
    font-size: 30px;
    bottom: 5px;
    right: 5px;
    background-color: white;
    border-radius: 56%;
}

.grid-card-image {
    height: 100%;
}

.grid-card-image-full {
    width: 100%;
    object-fit: inherit;
}

.grid-card-image-logo {
    width: 80%;
    object-fit: contain;
}

.grid-card-content {
    padding-bottom: 8px !important;
}

.grid-card-header {
    display: flex;
    align-items: center;
    justify-content: space-between;
    margin-bottom: 8px;
}

.grid-card-category {
    font-weight: bold;
    color: grey;
    text-transform: uppercase;
    font-size: 12px;
}

.grid-card-title {
    height: 47px;
    width: 90%;
    overflow: hidden;
    text-overflow: ellipsis;
    display: -webkit-box;
    -webkit-line-clamp: 2;
    -webkit-box-orient: vertical;
    white-space: normal;
    font-weight: bold;
    font-size: 16px;
}

.grid-card-description {
    height: 64px;
    width: 100%;
    overflow: hidden;
    text-overflow: ellipsis;
    display: -webkit-box;
    -webkit-line-clamp: 3;
    -webkit-box-orient: vertical;
    white-space: normal;
    color: grey;
    font-size: 14px;
}

.grid-card-product-row {
    margin-top: 5%;
    padding-top: 3px !important;
}

.grid-card-product-chip {
    font-size: small;
    background-color: #f9f3f3;
}

.grid-card-actions {
    display: flex;
    align-items: center;
    margin-top: auto;
    margin-left: 3%;
    padding-top: 0;
}

.grid-card-link-container {
    display: flex;
    align-items: center;
    padding-top: 0;
    float: left;
    font-size: 14px;
    margin-right: 10px;
    cursor: pointer;
}

.grid-card-community-icon {
    width: 2rem;
    height: 100%;
}

.grid-card-release-notes {
    margin-left: 5% !important;
}

.grid-card-release-icon {
    height: 100%;
    margin-right: 3px;
}

.grid-card-expand-button {
    border-radius: 50%;
    background-color: #F6F6F9;
    padding: 8px;
    margin-left: auto !important;
}

.grid-card-expand-button:hover {
    background-color: #e8e8eb;
}

.grid-card-dialog-paper {
    max-width: 680px;
    border-radius: 16px !important;
    overflow: hidden;
}
`, "",{"version":3,"sources":["webpack://./src/components/grid/GridCard.css"],"names":[],"mappings":"AAAA;IACI,cAAc;AAClB;;AAEA;IACI,YAAY;IACZ,YAAY;IACZ,iBAAiB;IACjB,aAAa;IACb,sBAAsB;IACtB,mBAAmB;IACnB,wCAAwC;IACxC,qBAAqB;IACrB,sBAAsB;AAC1B;;AAEA;IACI,gCAAgC;AACpC;;AAEA;IACI,mBAAmB;AACvB;;AAEA;IACI,gCAAgC;AACpC;;AAEA;IACI,gCAAgC;AACpC;;AAEA;IACI,gCAAgC;AACpC;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,uBAAuB;IACvB,gBAAgB;IAChB,kBAAkB;IAClB,aAAa;IACb,cAAc;AAClB;;AAEA;IACI,yBAAyB;AAC7B;;AAEA;IACI,yBAAyB;AAC7B;;AAEA;IACI,yBAAyB;AAC7B;;AAEA;IACI,yBAAyB;AAC7B;;AAEA;IACI,yBAAyB;AAC7B;;AAEA;IACI,WAAW;IACX,YAAY;IACZ,iBAAiB;AACrB;;AAEA;IACI,kBAAkB;IAClB,eAAe;IACf,WAAW;IACX,UAAU;IACV,uBAAuB;IACvB,kBAAkB;AACtB;;AAEA;IACI,YAAY;AAChB;;AAEA;IACI,WAAW;IACX,mBAAmB;AACvB;;AAEA;IACI,UAAU;IACV,mBAAmB;AACvB;;AAEA;IACI,8BAA8B;AAClC;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,8BAA8B;IAC9B,kBAAkB;AACtB;;AAEA;IACI,iBAAiB;IACjB,WAAW;IACX,yBAAyB;IACzB,eAAe;AACnB;;AAEA;IACI,YAAY;IACZ,UAAU;IACV,gBAAgB;IAChB,uBAAuB;IACvB,oBAAoB;IACpB,qBAAqB;IACrB,4BAA4B;IAC5B,mBAAmB;IACnB,iBAAiB;IACjB,eAAe;AACnB;;AAEA;IACI,YAAY;IACZ,WAAW;IACX,gBAAgB;IAChB,uBAAuB;IACvB,oBAAoB;IACpB,qBAAqB;IACrB,4BAA4B;IAC5B,mBAAmB;IACnB,WAAW;IACX,eAAe;AACnB;;AAEA;IACI,cAAc;IACd,2BAA2B;AAC/B;;AAEA;IACI,gBAAgB;IAChB,yBAAyB;AAC7B;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,gBAAgB;IAChB,eAAe;IACf,cAAc;AAClB;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,cAAc;IACd,WAAW;IACX,eAAe;IACf,kBAAkB;IAClB,eAAe;AACnB;;AAEA;IACI,WAAW;IACX,YAAY;AAChB;;AAEA;IACI,0BAA0B;AAC9B;;AAEA;IACI,YAAY;IACZ,iBAAiB;AACrB;;AAEA;IACI,kBAAkB;IAClB,yBAAyB;IACzB,YAAY;IACZ,4BAA4B;AAChC;;AAEA;IACI,yBAAyB;AAC7B;;AAEA;IACI,gBAAgB;IAChB,8BAA8B;IAC9B,gBAAgB;AACpB","sourcesContent":[".grid-card-container {\n    padding-top: 0;\n}\n\n.grid-card {\n    flex-grow: 1;\n    height: 100%;\n    min-height: 420px;\n    display: flex;\n    flex-direction: column;\n    border-radius: 12px;\n    box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);\n    padding: 0 !important;\n    background-color: #fff;\n}\n\n.grid-card-border-success {\n    border-bottom: 6px solid #4caf50;\n}\n\n.grid-card-border-secondary {\n    border-bottom: none;\n}\n\n.grid-card-border-info {\n    border-bottom: 6px solid #2196f3;\n}\n\n.grid-card-border-warning {\n    border-bottom: 6px solid #ff9800;\n}\n\n.grid-card-border-primary {\n    border-bottom: 6px solid #9c27b0;\n}\n\n.grid-card-media {\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    overflow: hidden;\n    position: relative;\n    height: 180px;\n    padding-top: 0;\n}\n\n.grid-card-media-success {\n    background-color: #4caf50;\n}\n\n.grid-card-media-secondary {\n    background-color: #9e9e9e;\n}\n\n.grid-card-media-info {\n    background-color: #2196f3;\n}\n\n.grid-card-media-warning {\n    background-color: #ff9800;\n}\n\n.grid-card-media-primary {\n    background-color: #9c27b0;\n}\n\n.grid-card-thumbnail {\n    width: 100%;\n    height: 100%;\n    object-fit: cover;\n}\n\n.grid-card-play-icon {\n    position: absolute;\n    font-size: 30px;\n    bottom: 5px;\n    right: 5px;\n    background-color: white;\n    border-radius: 56%;\n}\n\n.grid-card-image {\n    height: 100%;\n}\n\n.grid-card-image-full {\n    width: 100%;\n    object-fit: inherit;\n}\n\n.grid-card-image-logo {\n    width: 80%;\n    object-fit: contain;\n}\n\n.grid-card-content {\n    padding-bottom: 8px !important;\n}\n\n.grid-card-header {\n    display: flex;\n    align-items: center;\n    justify-content: space-between;\n    margin-bottom: 8px;\n}\n\n.grid-card-category {\n    font-weight: bold;\n    color: grey;\n    text-transform: uppercase;\n    font-size: 12px;\n}\n\n.grid-card-title {\n    height: 47px;\n    width: 90%;\n    overflow: hidden;\n    text-overflow: ellipsis;\n    display: -webkit-box;\n    -webkit-line-clamp: 2;\n    -webkit-box-orient: vertical;\n    white-space: normal;\n    font-weight: bold;\n    font-size: 16px;\n}\n\n.grid-card-description {\n    height: 64px;\n    width: 100%;\n    overflow: hidden;\n    text-overflow: ellipsis;\n    display: -webkit-box;\n    -webkit-line-clamp: 3;\n    -webkit-box-orient: vertical;\n    white-space: normal;\n    color: grey;\n    font-size: 14px;\n}\n\n.grid-card-product-row {\n    margin-top: 5%;\n    padding-top: 3px !important;\n}\n\n.grid-card-product-chip {\n    font-size: small;\n    background-color: #f9f3f3;\n}\n\n.grid-card-actions {\n    display: flex;\n    align-items: center;\n    margin-top: auto;\n    margin-left: 3%;\n    padding-top: 0;\n}\n\n.grid-card-link-container {\n    display: flex;\n    align-items: center;\n    padding-top: 0;\n    float: left;\n    font-size: 14px;\n    margin-right: 10px;\n    cursor: pointer;\n}\n\n.grid-card-community-icon {\n    width: 2rem;\n    height: 100%;\n}\n\n.grid-card-release-notes {\n    margin-left: 5% !important;\n}\n\n.grid-card-release-icon {\n    height: 100%;\n    margin-right: 3px;\n}\n\n.grid-card-expand-button {\n    border-radius: 50%;\n    background-color: #F6F6F9;\n    padding: 8px;\n    margin-left: auto !important;\n}\n\n.grid-card-expand-button:hover {\n    background-color: #e8e8eb;\n}\n\n.grid-card-dialog-paper {\n    max-width: 680px;\n    border-radius: 16px !important;\n    overflow: hidden;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
